import React from 'react';
import Notifications from '../Notifications';
import s from './LiveNotifications.scss';

const LiveNotifications: React.FC<{}> = () => (
  <Notifications wrapperClassName={s['root']} animatorClassName={s['animator']} queueName="live" />
);
LiveNotifications.displayName = 'LiveNotifications';

export default LiveNotifications;
